<template>
    <div class="versions" ref="versions">
        <span class="subtitle middle-sidebar-title is-5 has-text-weight-bold">
            <i @click="$emit('toggle_revision')"
               class="icon fas fa-times close has-text-grey pointer"></i> &nbsp;

            Change History
        </span><br/><br/>

        <note-details-version-modal
            @close="selected_version = null"
            @restored="$emit('restored')"
            :version="selected_version"
            :space="space"
            :note="note" />

        <div
            v-for="version in list.data.results"
            :key="version.id"
            @click="selected_version = version"
            class="list-item pointer">

            <avatar class="is-32x32 avatar" :user="version.user"/>

            <div>
                <b>{{version.user.first_name}} {{version.user.last_name}}</b>

                <p class="has-text-grey">
                    <base-datetime :date="version.created_at"/>
                </p>
            </div>
        </div>

        <mugen-scroll
            :should-handle="!list.loading && !last_page"
            :handler="load"
            scroll-container="versions"
            ref="scroll">

            <p v-if="!last_page">loading...</p>
        </mugen-scroll>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MugenScroll from 'vue-mugen-scroll';
import inViewport from 'element-in-view';
import Avatar from '../common/Avatar.vue';
import NoteDetailsVersionModal from './NoteDetailsVersionModal.vue';

export default {
    name: 'NoteDetailsRevisionList',
    components: { NoteDetailsVersionModal, Avatar, MugenScroll },
    props: ['space', 'note'],
    computed: {
        ...mapState('note_versions', ['list']),
    },
    data() {
        return { page: 1, last_page: false, selected_version: null };
    },
    methods: {
        load() {
            this.$store.dispatch('note_versions/list', {
                space_id: this.space.id,
                note_id: this.note.id,
                extend: this.page > 1,
                page: this.page,
            }).then(() => {
                this.page += 1;
                this.last_page = !this.list.data.next;

                // If marker (rel="scroll") in users display, load second page
                const in_element = inViewport(this.$refs.scroll.$el, { threshold: 0 });
                if (this.$refs.scroll && in_element && !this.last_page) {
                    this.load();
                }
            });
        },
    },
};
</script>

<style scoped>
    .versions {
        width: 25rem;
    }

    .list-item {
        padding-left: 0;
    }

    .avatar {
        float: left;
        margin-right: 0.5rem;
        margin-top: 0.55rem
    }
</style>
